import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { WarehouseGroupService } from '@app/core/locations/services/warehouse-group.service';
import { IWarehouseGroup } from 'v2/modules/shared/interfaces/location-warehouse.interface';

@Component({
  selector: 'filter-warehouse-group',
  templateUrl: './filter-warehouse-group.component.html',
  styleUrls: ['./filter-warehouse-group.component.scss'],
})
export class FilterWarehouseGroupComponent implements OnInit, OnDestroy {
  @Input() value :number | string;
  @Input() query :string[];
  @Output() warehouseGroupChange :EventEmitter<number | string> = new EventEmitter<
    number | string
  >();

  warehouseGroups$ :Observable<IWarehouseGroup[]>;
  warehouseGroupLoading$ :Observable<boolean>;
  warehouseGroups :IWarehouseGroup[] = [];

  private onDestroy$ = new Subject();

  constructor(private warehouseGroupService :WarehouseGroupService) {}

  ngOnInit() :void {
    if (typeof this.value === 'string') {
      this.value = parseInt(this.value);
    }
    this.getDataFromService();
    this.getAllWarehouseGroup();
  }

  ngOnDestroy() :void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }

  onWarehouseGroupChange() :void {
    this.warehouseGroupChange.emit(this.value);
  }

  trackWarehouseGroupByFn(item :IWarehouseGroup) :number {
    return item.id;
  }

  private getAllWarehouseGroup() :void {
    this.warehouseGroupService.getAll({
      all: 'true',
    });
  }

  private getDataFromService() :void {
    this.warehouseGroups$ = this.warehouseGroupService.warehouseGroup$;
    this.warehouseGroupLoading$ = this.warehouseGroupService.loading$;
  }
}
